import Vue from "vue";
import Vuex from "vuex";

import payableStores from "./modules/payables/index";
import newPayableStores from "./modules/newPayables/index";
import addresses from "./modules/addresses";
import orderCancellation from "./modules/orders/orderCancellation";

import preloader from "./modules/preloader";
import newOrder from "./modules/newOrder";
import professionalsSuggestion from "./modules/professionalsSuggestion";
import orders from "./modules/orders";
import subscriptions from "./modules/subscriptions";
import professionals from "./modules/professionals";
import user from "./modules/user";
import menu from "./modules/menu";
import physicals from "./modules/physicals";
import legals from "./modules/legals";
import states from "./modules/states";
import cities from "./modules/cities";
import districts from "./modules/districts";
import payments from "./modules/payments";
import coupons from "./modules/coupons";
import cycles from "./modules/cycles";
import newAddress from "./modules/newAddress";
import signUp from "./modules/signUp";
import accountTermsOfUse from "./modules/accountTermsOfUse";
import toast from "./modules/toast";
import allowProfessionalChangePreference from "./modules/orders/preferences/customer/allow_professional_change";
import requireProductsPreference from "./modules/orders/preferences/customer/require_products";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ...payableStores,
    ...newPayableStores,
    addresses,
    orderCancellation,

    preloader,
    newOrder,
    professionalsSuggestion,
    orders,
    subscriptions,
    professionals,
    user,
    menu,
    physicals,
    legals,
    states,
    cities,
    districts,
    payments,
    coupons,
    cycles,
    newAddress,
    signUp,
    accountTermsOfUse,
    toast,
    allowProfessionalChangePreference,
    requireProductsPreference
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js